import request from "@/common/request.js";

export function MessageAdd(data) {
  return request({
    url: "/system/messages/add",
    method: "post",
    params: data,
  });
}

// 获取联系方式信息
export function getContactInfo() {
  return request({
    url: "/system/contactInfo/get",
    method: "post",
  });
}
